// StartFromFilter
export default function StartFromFilter() {
	return function(input, start) {
		if (!input) {
		  return null;
		}
		start = +start; //parse to int
  
		if (!input.slice) return;
  
		return input.slice(start);
	};
}